import PropTypes from 'prop-types';
import moment from 'moment';

import { Box, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { customer } from 'evee-ui-common/types';

export const getJoinedText = (account) =>
  account.createdDate && `Joined in ${moment(account.createdDate).format('MMM YYYY')}`;

const UserInfo = ({ account, loading, ...rest }) => (
  <Box {...rest}>
    <Typography variant="h3" style={{ wordBreak: 'break-word' }}>
      {loading ? <Skeleton width="50%" /> : `Hi, I'm ${account.firstName}`}
    </Typography>
    <Typography variant="body1">
      {loading ? <Skeleton width="45%" /> : getJoinedText(account)}
    </Typography>
  </Box>
);

UserInfo.propTypes = {
  account: customer.customerPropType.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default UserInfo;
